// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ReportTabsPage_tabs__2KfHQ"};